<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="发布公告信息">
                <el-form-item 
                    label="变更标段" 
                    v-if="!listData.is_zbgg&&form.ggxzcode=='2'" 
                    class="table-full-row" prop="yggname"  
                    :rules="newRule('变更标段', 'required','blur')">
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox :label="v.bdcode" v-for="(v,i) in listData.bdlist" :value="v.bdcode" :key="i" style="width:100%;">{{v.bdname}}</el-checkbox>
                        </el-checkbox-group>
                </el-form-item>
                
                <el-form-item label="标段名称" prop="bdnames" v-if="form.ggxzcode=='1'"  class="table-full-row" :rules="newRule('标段名称', 'required','blur','sensitiveWords')">
                    {{form.bdnames||'-'}}<el-button type="text" @click="OpenBdDialog()" icon="el-icon-plus" style="margin-left:20px;">点击选取标段</el-button>
                </el-form-item>
                <el-form-item label="原公告名称"  class="table-full-row" v-if="form.yggcode!==null&&form.yggcode!==''" prop="yggname"  :rules="newRule('原公告名称', 'required','blur','sensitiveWords')">
                    <el-input type="text"  v-model="form.yggname" disabled></el-input>
                </el-form-item>
                <el-form-item label="公告名称" prop="ggname"  class="table-full-row" :rules="newRule('公告名称', 'required','blur','sensitiveWords')">
                    <el-input type="text" placeholder="请输入公告名称" v-model="form.ggname"></el-input>
                </el-form-item>
                <el-form-item label="是否变更招标文件获取截止时间" prop="is_ggendtime" v-if="form.ggxzcode=='2'" :rules="newRule('是否变更招标文件获取截止时间', 'required','change')" :class="{'table-full-row': form.is_ggendtime!='1'}">
                    <el-radio-group v-model="form.is_ggendtime">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="招标文件获取截止时间" prop="ggendtime"  v-if="form.ggxzcode=='2'&&form.is_ggendtime==='1'" key="ggendtime" :rules="newRule('招标文件获取截止时间', 'required','blur')">
                    <el-date-picker v-model="form.ggendtime"  type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择招标文件获取截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否变更响应文件递交截止时间" prop="is_wjdjjztime" v-if="form.ggxzcode=='2'"  :rules="newRule('是否变更响应文件递交截止时间', 'required','change')" :class="{'table-full-row': form.is_wjdjjztime!='1'}">
                    <el-radio-group v-model="form.is_wjdjjztime">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="响应文件递交截止时间"  v-if="form.ggxzcode=='2'&&form.is_wjdjjztime==='1'"  key="xywjdjjzsj" prop="xywjdjjzsj" :rules="newRule('响应文件递交截止时间', 'required','change')">
                    <el-date-picker v-model="form.xywjdjjzsj" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择响应文件递交截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否变更解密截止时间" v-if="form.ggxzcode=='2'" prop="is_extjmjstime"  :rules="newRule('是否变更解密截止时间', 'required','change')" :class="{'table-full-row': form.is_extjmjstime!='1'}">
                    <el-radio-group v-model="form.is_extjmjstime">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="解密截止时间" prop="extjmjstime"  v-if="form.ggxzcode=='2'&&form.is_extjmjstime==='1'" key="extjmjstime" :rules="newRule('解密截止时间', 'required','change')">
                    <el-date-picker v-model="form.extjmjstime" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择解密截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否变更投标人最晚质疑截止时间" v-if="form.ggxzcode=='2'" prop="is_questionendday"  :rules="newRule('是否变更投标人最晚质疑截止时间', 'required','change')" :class="{'table-full-row': form.is_questionendday!='1'}">
                    <el-radio-group v-model="form.is_questionendday">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="质疑截止时间" prop="questionendday"  v-if="form.ggxzcode=='2'&&form.is_questionendday==='1'" key="questionendday" :rules="newRule('质疑截止时间', 'required','change')">
                    <el-date-picker v-model="form.questionendday" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择质疑截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="公告内容文本" prop="ggcontent" class="table-full-row"  :rules="newRule('公告内容文本', 'required','change','sensitiveWords')">
                    <el-button v-if="form.bdcodes!==''" type="success" @click="neirong()">自动生成公告（内容可修改）</el-button>
                    <ueditor v-model="form.ggcontent" />
                </el-form-item>
                <el-form-item label="公告发布时间" prop="ggfbtime"  v-if="form.ggxzcode=='1'"  :rules="newRule('公告发布时间', 'required','change')">
                    <el-date-picker v-model="form.ggfbtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择公告发布时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="公告发布时间与下载文件时间是否一致" v-if="form.ggxzcode=='1'" prop="is_wjhqsj"  :rules="newRule('公告发布时间与下载文件时间是否一致', 'required','change')">
                    <el-radio-group v-model="form.is_wjhqsj">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="招标文件获取开始时间"  prop="wjhqtime"  v-if="form.ggxzcode=='1'&&form.is_wjhqsj==='0'"  :rules="newRule('招标文件获取开始时间', 'required','change')">
                    <el-date-picker v-model="form.wjhqtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择招标文件获取开始时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="公告结束时间" prop="ggendtime"  v-if="form.ggxzcode=='1'"  :rules="newRule('公告结束时间', 'required','change')">
                    <el-date-picker v-model="form.ggendtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择公告结束时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="响应文件递交截止时间" prop="xywjdjjzsj"  v-if="form.ggxzcode=='1'" key="xywjdjjzsj" :rules="newRule('响应文件递交截止时间', 'required','change')">
                    <el-date-picker v-model="form.xywjdjjzsj" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择响应文件递交截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="解密截止时间" prop="extjmjstime"  v-if="form.ggxzcode=='1'" key="extjmjstime" :rules="newRule('解密截止时间', 'required','change')">
                    <el-date-picker v-model="form.extjmjstime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" placeholder="选择解密截止时间" :picker-options='datePickerOptions'>
                    </el-date-picker>
                </el-form-item>
            </my-form-item-group>
            <template slot="btn" class="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-check" type="primary" @click="fSave('1',scope.submitHandler)">
                    提交
                </el-button>
                <el-button  icon="el-icon-remove-outline" type="warning" @click="fSave('0',scope.submitHandler)">
                    暂存
                </el-button>    
            </template>
            <el-dialog  :visible.sync="bddialogVisible" title="选择标段" width="40%">
                <div style="height:520px;">  
                    <!-- <div style="margin:20px 0">
                        标段名称：<el-input type="text" v-model="txtkey" style="width:500px;margin-right:10px;"></el-input>
                        <el-button type="warning" @click="bidsearch()">搜索</el-button>
                    </div>             -->
                    <div style="width:97%;padding:10px 10px; height:400px;border:1px solid #0095FF;overflow-y:scroll;overflow-x:hidden">
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox :label="v.bdcode" v-for="(v,i) in listData.bdlist" :value="v.bdcode" :key="i" style="width:100%;">{{v.bdname}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="width:100%;text-align:center;position:absolute;bottom:10px;">
                        <el-button type="primary" @click="setbdnames()">选择</el-button>
                    </div>
                </div>
            </el-dialog>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        return{
            checkList:[],
            bdlist:[],
            txtkey:'',
            bddialogVisible:false,
            form:{
                shbj:'',
                yggcode:'',
                ggname:'',
                procode:'',
                is_ggendtime:'',
                zbwjendtime:'',
                is_wjdjjztime:'',
                kbsjtime:'',
                is_extjmjstime:'',
                is_questionendday:'',
                iquestionendday: '',
                jmtime:'',
                ggcontent:'',
                bdnames:'',
                bdcodes:'',
                ggfbtime:'',
                ggendtime:'',
                is_wjhqsj:'1',
                wjhqtime:'',
                gglxcode:'',
                gglxname:''                  
            },
            listData:{
                bdlist:[],
                is_zbgg:''
            },
            // 开始时间
            datePickerOptions: {
                disabledDate(time){
                    return time.getTime() < Date.now()-8.64e7
                }
            },
          

        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        //选择标段
        OpenBdDialog:function(){
            this.bddialogVisible=true;
        },    
        //搜索标段
        bidsearch:function(){

        },
        setbdnames:function(){
            this.form.bdcodes=this.checkList.toString();
            var arr=[];
            var bdlist=this.listData.bdlist;
            var checkList=this.checkList;
            for(var i=0;i<bdlist.length;i++){
                for(var j=0;j<this.checkList.length;j++){
                    if(checkList[j]===bdlist[i].bdcode){
                        arr.push(bdlist[i].bdname);                    
                    }
                }
            } 
            this.form.bdnames=arr.toString();
            this.bddialogVisible=false;
        },
        //自动生成公告
        neirong:function(){
            var that = this;
            if(this.form.yggcode!==null&&this.form.yggcode!==''&&this.form.yggcode!==undefined){
                this.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/getContent2.json`,{yggcode:this.form.yggcode},(data,res)=>{
                    if(res.code==='v'){
                        that.form.ggcontent=data;
                    }
                })            
            }else{                            
                this.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/getContent.json`,{bdcodes:this.form.bdcodes},(data,res)=>{
                    if(res.code==='v'){
                        that.form.ggcontent=data;
                    }
                })                
            }
        },
        // 提交
        fSave:function(id,cb){   
            if(this.checkList.length==0){
                ShowMsg('请选择标段！','warning')
                return
            }
            this.form.bdcodes = this.checkList.toString() + ','
            var arr = []
            for(var i = 0; i<this.listData.bdlist.length; i++){
                for(var j = 0; j<this.checkList.length; j++){
                    if(this.listData.bdlist[i].bdcode == this.checkList[j]){
                        arr.push(this.listData.bdlist[i].bdname)
                    }
                }
            }
            this.form.bdnames = arr.toString() + ','
            this.form.shbj=id;
            cb();
        },
        submitHandler:function(){
            var that=this;        
            that.form.gglxcode = "1";
            that.form.gglxname = "招标公告";
            that.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/add2.json`,this.form, (data, res) => {
                if (res.result) {
                    ShowMsg(res.msg,'success');
                    that.cancleHandler();
                } else {
                    ShowMsg(res.msg);
                }
            });
        },

        lowerJSONKey(json) {
            if (json instanceof Array) {
                for (var key in json) {
                this.lowerJSONKey(json[key]);
                }
            } else if (json instanceof Object) {
                for (var key in json) {
                var reg = /[A-Z]+$/;
                if (json[key] instanceof Object || json[key] instanceof Array) {
                    this.lowerJSONKey(json[key]);
                } else {
                    if (reg.test(key)) {
                    var lowerKey = key.toLowerCase();
                    json[lowerKey] = json[key];
                    delete json[key];
                    }
                }
                }
            }
            return json;
        },
    },
    created() {
        var that=this
        this.showform=false;
        if(this.$route.query.yggcode!==undefined){
            this.form.yggcode=that.$route.query.yggcode;
            this.form.procode=this.$route.query.procode;
            this.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/edit2.json`,{
                procode:this.$route.query.procode,
                yggcode:that.$route.query.yggcode
            },(data,res)=>{
                if(res.code==='v'){
                    var model = data.restmodel;
                    that.form=model;
                    if(model.bdcodes===''||model.bdcodes===null||model.bdcodes===undefined){
                        that.form.bdcodes='';
                    }else{
                        that.checkList=model.bdcodes.split(',');
                    }
                    if(this.form.is_ggendtime===null){
                        this.form.is_ggendtime='';
                    }
                    if(this.form.is_wjdjjztime===null){
                        this.form.is_wjdjjztime='';
                    }
                    if(this.form.is_extjmjstime===null){
                        this.form.is_extjmjstime='';
                    }
                    if(this.form.is_questionendday===null){
                        this.form.is_questionendday='';
                    }
                    that.lowerJSONKey(data.bdlist)
                    that.listData.bdlist=data.bdlist;
                }
            })
        }else if(this.$route.query.ggcode!==undefined){
            this.form.procode=this.$route.query.procode;
            this.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/edit2.json`,{
                procode:this.$route.query.procode,
                id:this.$route.query.ggcode
            },(data,res)=>{
                if(res.code==='v'){
                    var model = data.restmodel;
                    that.form=model;
                    if(model.bdcodes===''||model.bdcodes===null||model.bdcodes===undefined){
                        that.form.bdcodes='';
                    }else{
                        that.checkList=model.bdcodes.split(',');
                    }
                    // that.form.gglxname=that.form.ggxzname;
                    that.lowerJSONKey(data.bdlist)
                    that.listData.bdlist=data.bdlist;
                    that.listData.bdlist=data.bdlist;
                }
            })
        }else{
            this.form.procode=this.$route.query.procode;
            this.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/edit2.json`,{
                procode:this.$route.query.procode
            },(data,res)=>{
                if(res.code==='v'){
                    var model = data.restmodel;
                    if(model.ggfbtime===null){
                        model.ggfbtime='';
                    } 
                    if(model.ggendtime===null){
                        model.ggendtime='';
                    }
                    if(model.xywjdjjzsj===null){
                        model.xywjdjjzsj=undefined;
                    }
                    if(model.extjmjstime===null){
                        model.extjmjstime=undefined;
                    }
                    if(model.xywjdjjzsj===null){
                        model.xywjdjjzsj=undefined;
                    }
                    that.form=model;
                    if(model.bdcodes===''||model.bdcodes===null||model.bdcodes===undefined){
                        that.form.bdcodes='';
                    }else{
                        that.checkList=model.bdcodes.split(',');
                    }
                    that.lowerJSONKey(data.bdlist)
                    that.listData.bdlist=data.bdlist;
                    that.listData.bdlist=data.bdlist;
                }
            })
        }
        
    },
    mounted() {
        var that=this;
   
    }
}
</script>

<style scoped lang="scss">
.download{
    color:green;
}
.download:hover{
    text-decoration: burlywood;
}

</style>
